
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Search } from "lucide-react";

interface NewsAlertsFiltersProps {
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  showUnreadOnly: boolean;
  onShowUnreadOnlyChange: (show: boolean) => void;
}

export const NewsAlertsFilters: React.FC<NewsAlertsFiltersProps> = ({
  searchTerm,
  onSearchTermChange,
  showUnreadOnly,
  onShowUnreadOnlyChange,
}) => {
  return (
    <div className="flex items-center gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search news alerts..."
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="pl-10"
        />
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={showUnreadOnly}
          onCheckedChange={onShowUnreadOnlyChange}
          id="unread-filter"
        />
        <label htmlFor="unread-filter" className="text-sm">
          Unread only
        </label>
      </div>
    </div>
  );
};
